// src/utils/loadAnalytics.js

export function loadGoogleAnalytics() {
  if (!window.gtag) {
    // Load the gtag.js script
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-XJEQE1EPYC"; // Replace with your ID
    script.async = true;
    document.head.appendChild(script);

    // Declare gtag outside and assign
    window.dataLayer = window.dataLayer || [];
    const gtag = (...args) => {
      window.dataLayer.push(args);
    };

    window.gtag = gtag;

    gtag("js", new Date());
    gtag("config", "G-XJEQE1EPYC");
    console.log("📊 Google Analytics loaded");
  }
}
